module.exports = __webpack_public_path__ + "img/image5.d8e269d7.jpg";